import React, { useState } from "react";
import LoginForm from "./loginForm";
import SignupForm from "./signupForm";
import MaaranLogoColor from "../../assets/images/maaran_colour_black_with tag.svg";
import MaaranLogoWhite from "@/assets/images/Maaran_colour_white_with tag.svg";
import Image from "next/image";
import useDarkMode from "@/hooks/useDarkMode";

export default function Index() {
  const [currentTab, setCurrentTab] = useState("login");
  const {isDarkMode} = useDarkMode();

  return (
    <div className="grid min-h-svh lg:grid-cols-2">
      <div className="bg-muted flex justify-center items-center ">
        <div className="w-[40rem] h-[40rem] relative">
          <Image
            src={isDarkMode ? MaaranLogoWhite : MaaranLogoColor}
            alt="Maaran Logo"
            fill
            className="object-contain"
          />
        </div>
      </div>

      <div className="flex flex-col gap-4 p-6 md:p-10 bg-background h-screen  overflow-auto">
        <div className="flex flex-1 items-center justify-center ">
          <div className="w-full max-w-[38rem]">
            {currentTab == "signup" ? (
              <SignupForm setCurrentTab={setCurrentTab} />
            ) : (
              <LoginForm setCurrentTab={setCurrentTab} />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export function EmailInsteadText() {
  return (
    <div className="flex items-center  w-full sm:mb-4 mt-3 font-poppins text-[#616161] gap-4 fs-12">
      <hr className="flex-grow border-gray-300" />
      <span className="whitespace-nowrap">Or use Email</span>
      <hr className="flex-grow border-gray-300" />
    </div>
  );
}
